import React, { useEffect, useState } from 'react';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import { Grid, Box } from '@mui/material';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CustomFileUploading from '../../../components/CustomFileUploading/CustomFileUploading';
import ModalFooter from '../../CustomModal/ModalFooter';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import _ from 'lodash';
import moment from 'moment';
import toast from 'react-hot-toast';
import CompDirection from '../../../themes/CompDirection';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allEmpDocTypes: [];
  allCountires: [];
  callBackGetData: (data: any) => void;
  trans?: any;
}
const AddDependentsPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allEmpDocTypes,
  allCountires,
  trans,
}: ModalProps) => {
  const [document_type, setdocument_type] = useState('');
  const [countryName, setCountryName] = useState('');
  const [countryId, setCountryId] = useState();
  const [EmpDocTypeId, setEmpDocTypeId] = useState();
  const [identifierNo, setIdentifierNo] = useState('');
  const [remarks, setRemarks] = useState('');
  const [issueDate, setissueDate] = useState<any>(new Date());
  const [expiredDate, setExpiredDate] = useState<any>(new Date());
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');
  const [newattachement, setNewAttachement] = useState(false);
  const [proofAttachment, setProofAttachment] = useState(null);
  const [proofAttachmentPath, setProofAttachmentPath] = useState('');

  const Handledocumenttype = (document_type: any) => {
    const EmpDocTypes = _.filter(allEmpDocTypes, function (c: any) {
      return c.type === document_type;
    });
    if (EmpDocTypes.length) {
      const empdocty = EmpDocTypes[0];
      setEmpDocTypeId(empdocty.id);
      setdocument_type(document_type);
    }
  };
  const handleSetCounty = (countryName: any) => {
    const country = _.filter(allCountires, function (c: any) {
      return c.name === countryName;
    });
    if (country.length) {
      const cnty = country[0];
      setCountryId(cnty.id);
      setCountryName(countryName);
    }
  };

  const attachmentUpload = (e: any) => {
    const file: any = e.target.files[0];
    setNewAttachement(true);
    if (file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;
      setProofAttachment(image_as_files);
      setProofAttachmentPath(image_as_base64);
    } else {
      setIsPDF(true);
      setPDFName(file?.name);
      setProofAttachment(file);
    }
  };
  const handleSubmit = () => {
    if (issueDate > expiredDate) {
      toast.error(trans('Expire date must be greater than issue date'));
    } else {
      const issue_Date = moment(issueDate.$d).format('YYYY-MM-DD');
      const expired_Date = moment(expiredDate.$d).format('YYYY-MM-DD');

      if (!EmpDocTypeId) {
        toast.error(trans('Please fill the DocumentType fields'));
      } else {
        callBackGetData({
          documentTypeId: EmpDocTypeId,
          countryName: countryName,
          issueDate: issue_Date,
          expiredDate: expired_Date,
          identifierNo: identifierNo,
          remarks: remarks,
          file: proofAttachment,
          newattachement: newattachement,
        });
        closeModal();
      }
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Add Documents') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '10px',
          }}
        >
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Document Type')}
              value={document_type}
              options={_.map(allEmpDocTypes, (EmpDoctype: any) => {
                return EmpDoctype.type;
              })}
              onChange={(event: any, newValue: any) => {
                Handledocumenttype(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Issue Country')}
              options={_.map(allCountires, (country: any) => {
                return country.name;
              })}
              value={countryName}
              onChange={(event: any, newValue: any) => {
                handleSetCounty(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomDatePicker
              label={trans('Issue Date')}
              value={new Date(issueDate)}
              onChange={(newValue: any) => {
                setissueDate(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomDatePicker
              label={trans('Expire Date')}
              value={new Date(expiredDate)}
              onChange={(newValue: any) => {
                setExpiredDate(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomTextField
              type=""
              label={trans('Identifier Number')}
              placeholder={trans('Identifier Number')}
              value={identifierNo}
              onChange={(e: any) => setIdentifierNo(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em' }}>
            <CustomTextField
              type=""
              label={trans('Remarks')}
              placeholder={trans('Remarks')}
              value={remarks}
              onChange={(e: any) => setRemarks(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} style={{ marginTop: '0.5em', flexGrow: 1 }}>
            <DropAndSelect
              upload={attachmentUpload}
              src={proofAttachmentPath}
              isAttachmentSigned={true}
              isPDF={isPDF}
              pdfName={pdfName}
              onDelete={() => {
                setPDFName('');
                setIsPDF(false);
                setProofAttachmentPath('');
                setNewAttachement(false);
              }}
            />
          </Grid>
        </Grid>
      </CompDirection>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};
export default AddDependentsPresenter;
